export default __webpack_public_path__ + "static/media/clients.6a8dd2e8.svg";